import { cx } from "../../lib/cx.js";
/* empty css            */
import { jsx } from "react/jsx-runtime";
//#region src/components/Heading/Heading.tsx
/**
* A heading element in one of the type roles, with no margin. The level gives the
* outline and the size gives the look, so a small section heading can still be an h3.
*/
function Heading({ level, size, className, ...rest }) {
	const Element = `h${level}`;
	return /* @__PURE__ */ jsx(Element, {
		className: cx("ds-heading", `ds-heading--${size}`, className),
		...rest
	});
}
//#endregion
export { Heading };

//# sourceMappingURL=Heading.js.map